<template>
    <flex-element class="rich-text" :class="htmlClass" :element-type="elementType">
        <div v-html="richText" />
    </flex-element>
</template>

<script>
import baseAtom from '@/mixins/base-atom/base-atom-dumb';

export default {
    name: 'a-rich-text',
    mixins: [baseAtom],

    props: {
        richText: {
            type: String,
            default: '',
        },
    },
};
</script>
